import { render, staticRenderFns } from "./Mention.vue?vue&type=template&id=df4d496e&scoped=true&"
import script from "./Mention.vue?vue&type=script&lang=js&"
export * from "./Mention.vue?vue&type=script&lang=js&"
import style0 from "./Mention.vue?vue&type=style&index=0&id=df4d496e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4d496e",
  null
  
)

export default component.exports